// The server re-indexes a section's whole display_order set on every reorder. After an
// optimistic array move, the cached values still belong to the pre-move positions, so a
// later getDropResult read would compute its target from a numbering the server no longer
// holds. Redistributing the section's own existing values across the new positions restores
// that invariant without guessing the server's numbering scheme.
export const reassignDisplayOrders = <T extends { displayOrder: number }>(items: T[]): T[] => {
  const sortedDisplayOrders = items.map(({ displayOrder }) => displayOrder).sort((a, b) => a - b);

  return items.map((item, index) => ({ ...item, displayOrder: sortedDisplayOrders[index] }));
};
